import { useSelector, useDispatch } from "react-redux";
import {
  addCourse,
  deleteCourse,
  getActiveCourse,
  getAllCourse,
  getDepartment,
  getProgram,
  updateCourse,
  setOffset,
  setPage,
  setPerPage,
} from "../store/course";

function useCourse() {
  const dispatch = useDispatch();

  const courseData = useSelector((state) => state.course.data);
  const programData = useSelector((state) => state.course.program);
  const departmentData = useSelector((state) => state.course.department);
  const getActiveCourseData = useSelector((state) => state.course.activeData);
  const loading = useSelector((state) => state.course.loading);
  const deleteLoading = useSelector((state) => state.course.deleteLoading);
  const dataLoading = useSelector((state) => state.course.dataLoading);
  const activeCourseId = useSelector((state) => state.course.activeCourse);

  const page = useSelector((state) => state.course?.page);
  const perPage = useSelector((state) => state.course?.perPage);
  const offset = useSelector((state) => state.course?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));


  const getAllCourseAction = (params) => dispatch(getAllCourse(params));
  const getDepartmentAction = (params) => dispatch(getDepartment(params));
  const getProgramAction = (params) => dispatch(getProgram(params));
  const addCourseAction = (params) => dispatch(addCourse(params));
  const updateCourseAction = (params) => dispatch(updateCourse(params));
  const getActiveCourseAction = (params) => dispatch(getActiveCourse(params));
  const deleteCourseAction = (params) => dispatch(deleteCourse(params));

  return {
    // states
    courseData,
    programData,
    departmentData,
    getActiveCourseData,
    loading,
    deleteLoading,
    dataLoading,
    activeCourseId,

    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,

    getAllCourseAction,
    getDepartmentAction,
    getProgramAction,
    addCourseAction,
    updateCourseAction,
    getActiveCourseAction,
    deleteCourseAction,
  };
}

export default useCourse;
